import React, {Component} from 'react';
import {request} from "../../helper/APIUtils";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import MiniButton from "../../components/MiniButton";
import Table from "../../components/Table/Table";
import {getEntegratorConf, showAxiosError} from "../../helper/helper";
import SweetAlert from "react-bootstrap-sweetalert";
import NavBarKS from "../../components/NavBarKS";
import StickButton from "../../components/StickButton";
import moment from "moment";
import BuildReportModal from "./BuildReportModal";
import Alert from "react-s-alert";
import ReportSettingModal from "./ReportSettingModal";
import {showReportSettingButton} from "../../helper/permission";
import {EntegratorConf, VirtualHost} from "../../constants";
import costs from "../invoice/component/Costs";

class ExcelRequest extends Component {

    constructor(props) {
        super(props);
        this.notify = React.createRef();
        this.state = {
            alert: null,
            loading: true,
            manual: false,
            content: [],
            total: 0,
            searching: false,
            searchQuery: undefined,
            page: 0,
            size: 10,
            searchKey: "",
            mode:'create',
            selectedItem:null,
            showSearchModal: props.sgkCiroReport && props.sgkCiroReport === true,
            selection: [],
            selectedAll: false,
            showReportSettingsModal: false,
        };
        this.fetchData = this.fetchData.bind(this);
        this.searchWithKey = this.searchWithKey.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
        this.download = this.download.bind(this);
        this.getStatus = this.getStatus.bind(this);
        this.copySelected = this.copySelected.bind(this);
        this.getReportTypesForSearch = this.getReportTypesForSearch.bind(this);
        this.findAccesor = this.findAccesor.bind(this);
        this.isSelected = this.isSelected.bind(this);
        this.toggleCheckboxChange = this.toggleCheckboxChange.bind(this);
        this.deleteSelected = this.deleteSelected.bind(this);
    }

    componentDidMount() {
        this.getReportTypesForSearch();
        let isCreditSufficient = this.props.isCreditSufficient!=undefined ? this.props.isCreditSufficient:true;
        this.setState({isCreditSufficient});
    }

    copySelected(row){
        this.setState({selectedItem:row, showSearchModal:true, mode:'copy'});
    }


    handleSearch(searchQuery) {
        if(searchQuery !== "" ){
            searchQuery = searchQuery.includes("efaturadb.outbox") ? searchQuery.replace("efaturadb.outbox","eFaturaDB.outbox") :
                (searchQuery.includes("efaturadb.inbox") ? searchQuery.replace("efaturadb.inbox","eFaturaDB.inbox" ):
                    (searchQuery.includes("EARSIVFATURA") ? searchQuery.replace("EARSIVFATURA","eArsivDB.archive_invoice") :
                        (searchQuery.includes("MUSTAHSILMAKBUZ") ? searchQuery.replace("reportType=MUSTAHSILMAKBUZ","documentType=MUSTAHSILMAKBUZ"):
                            (searchQuery.includes("SERBESTMESLEKMAKBUZ") ? searchQuery.replace("reportType=SERBESTMESLEKMAKBUZ","documentType=SERBESTMESLEKMAKBUZ") :
                                (searchQuery.includes("GIDERPUSULASI") ? searchQuery.replace("reportType=GIDERPUSULASI","documentType=GIDERPUSULASI") :
                                    (searchQuery.includes("MIKRO") ? searchQuery.replace("reportType=MIKRO","documentType=MIKRO") :
                                        (searchQuery.includes("ALLINVOICE") ? searchQuery.replace("reportType=ALLINVOICE", "documentType=ALLINVOICE") :
                                            (searchQuery.includes("EARSIV5BINOTUZBIN") ? searchQuery.replace("reportType=EARSIV5BINOTUZBIN", "documentType=EARSIV5BINOTUZBIN") :
                                                (searchQuery.includes("EXCHANGE") ? searchQuery.replace("reportType=EXCHANGE", "documentType=EXCHANGE") :
                                                    (searchQuery.includes("ADISYON") ? searchQuery.replace("reportType=ADISYON", "documentType=ADISYON") :
                                                        (searchQuery.includes("ECZACIPOS") ? searchQuery.replace("reportType=ECZACIPOS", "documentType=ECZACIPOS") :
                                                            (searchQuery.includes("DESPATCHADVICE") ? searchQuery.replace("DESPATCHADVICE", "eFaturaDB.despatch_outbox") : searchQuery))))))))))));
        }
        this.setState({
            searchQuery,
            searching: true
        }, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
    }

    searchWithKey(e) {
        this.setState({searchKey: e.target.value, manual: true});
    }

    fetchData(accessor, direction, page, size) {
        let self = this;
        let type = this.props.hasLine ? 1 : 0;
        let sortStr = accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '&sort=createdAt,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: '/excelRequest/fetch/' + type + '?page=' + page + '&size=' + size + searchQuery + sortStr,
            method: "get",
        };
        self.setState({loading: true, searching: true, manual: self.manual === true ? false : self.manual});
        self.props.reload(true);
        request(params)
            .then(function (response) {
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    content: response.data.content,
                    loading: false,
                    searching: false
                });
                self.props.reload(false);
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            self.props.reload(false);
            showAxiosError(error);
        });
    }

    deleteRow(row) {
        let self = this;
        let params = {
            url: "/excelRequest/delete",
            method: "post",
            data: row.recordId
        };
        self.setState({deleteBtnDisabled:true});
        request(params).then(() => {
            self.setState({alert: null,deleteBtnDisabled:false});
            self.props.reload(true, "sidebar");
        }).catch(function (error) {
            self.setState({loading: false, searching: false, alert: null,deleteBtnDisabled:false});
            self.props.reload(true, "sidebar");
            showAxiosError(error);
        });
    }

    download(row) {
        let self = this;
        let params = {
            url: `/excelRequest/download`,
            responseType: 'arraybuffer',
            method: "post",
            data: row.recordId
        };
        request(params)
            .then(function (response) {
                let blob = new Blob([response.data], {type: response.headers["content-type"]});
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                let date = new Date();
                link.download = row.vknTckn + "_" + row.documentType + "_" + row.reportType.split(".")[1] +"_"+
                    date.getFullYear() + "_" +
                    date.getMonth() + "_" +
                    date.getDate() + "_" +
                    date.getHours() + "_" +
                    date.getMinutes() + "_" +
                    date.getSeconds() + ".xlsx";
                document.body.appendChild(link);
                link.click();
                self.setState({loading: false});
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    getStatus(item) {
        if (item.result === "0")
            return "Talebiniz sıraya alınmıştır.";
        else if (item.result === "1")
            return "Raporunuz hazırlanma aşamasındadır.";
        else if (item.result === "2" && item.path !== null)
            return "Raporunuz indirmeye hazırdır.";
        else if (item.result === "2" && item.path === null)
            return "Seçtiğiniz aralıkta fatura bulunmamaktadır.";
        else if (item.result === "3")
            return item.resultExplanation ? item.resultExplanation : "Raporunuz hazırlanamadı.";
        else if (item.result === "4")
            return "Seçtiğiniz aralıkta belge bulunmamaktadır."
        else
            return "";
    }

    getDate(date){
        return moment(date).isValid() ? moment(date).format("DD-MM-YYYY") : '';
    }

    getTime(dateTime){
        return moment(dateTime).isValid() ? moment(dateTime).format("DD-MM-YYYY HH:mm:ss") : '';
    }

    getReportType(item) {
        const reportTypeSplit = item.reportType.split(".");
        if (reportTypeSplit.length > 1) {
            const reportType = reportTypeSplit[1];
            return (reportType === "outbox" || reportType.indexOf("outbox_") !== -1) ? "Giden Fatura" : (reportType === "inbox" || reportType.indexOf("inbox_") !== -1 ? "Gelen Fatura" : item.documentType);
        } else if (reportTypeSplit.includes("SGK_REPORT")){
            return "Giden Fatura";
        }

        return item.documentType;
    }

    getReportTypesForSearch(){
        let self = this;
        request({
            url: `/excelXpath/getExcelHeaderList`,
            method: 'post',
            data: "getReportTypesForSearch"
        }).then(response => {
            let data = response.data;
            let excelHeaderList = data.excelHeaderList;
            let reportType = excelHeaderList.map(service => ({
                    value: service.type === "eFaturaDB.inbox" ? service.type :
                        (service.type ==="eFaturaDB.outbox" ? service.type :
                            (service.type === "eFaturaDB.inbox_transfer" ? service.type : (service.type === "eFaturaDB.outbox_transfer" ? service.type : (service.type === "eArsivDB.archive_invoice_transfer" ? service.type :service.documentType)))),
                    label: service.type ==="eFaturaDB.outbox" ? "GİDEN FATURA" : (service.type ==="eFaturaDB.inbox"  ?
                        "GELEN FATURA" : (service.type === "eFaturaDB.inbox_transfer" ? "GELEN TRANSFER FATURA":
                            (service.type === "eFaturaDB.outbox_transfer" ? "GİDEN TRANSFER FATURA": ((service.type === "eArsivDB.archive_invoice_transfer" ? "EARŞİV TRANSFER FATURA" : service.documentType)))))
            }));
            let unique = [];
            for(let i = 0; i < reportType.length; i++ ){
                let counter = 0;
                if(i === 0){
                    unique.push({value: null, label: "Tümü"});
                    unique.push(reportType[i]);
                }else {
                    unique.map(uni => {
                        if(uni.label === reportType[i].label){
                            counter++;
                        }
                    });
                    if(counter === 0){
                        unique.push(reportType[i]);
                    }
                }
            }
            reportType = unique;
            self.setState({excelHeaderList,reportType});
        }).catch(error => {
            showAxiosError(error);
            self.setState({loading:false});
        });
    }

    findAccesor(){
        return "documentType";
    }

    isSelected(id) {
        return (this.state.selection.indexOf(id) !== -1);
    }

    toggleCheckboxChange(e, row, id) {
        let self = this;
        let checked = e.target.checked;
        let items = self.state.content;
        let selection = self.state.selection;
        if (row === "all") {
            let selection = [];
            if (checked) {
                items.forEach(item => {
                    selection.push(item[id]);
                });
            }
            self.setState({selection: selection, selectedAll: checked});
        } else {
            let index = selection.indexOf(row[id]);
            if (index >= 0) {
                selection = [
                    ...selection.slice(0, index),
                    ...selection.slice(index + 1)
                ];
            } else {
                selection.push(row[id]);
            }
            self.setState({
                selection: selection,
                selectedAll: ((selection.length > 0) ? (selection.length === self.state.content.length) : false)
            });
        }
    }

    deleteSelected() {
        let self = this;
        let selection = self.state.selection;
        let params = {
            url:`/excelRequest/deleteMultiple`,
            method :'post',
            data: selection
        };
        self.setState({deleteBtnDisabled:true});
        request(params)
            .then(function (response) {
                self.setState({loading: false, deleteBtnDisabled: false, manual: true, selection: [], selectedAll: false});
                Alert.success("Silme işlemi başarıyla gerçekleştirildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000,
                    html:false
                });
            }).catch(function (error) {
            self.setState({loading: false,deleteBtnDisabled:false, selection: [], selectedAll: false});
            showAxiosError(error);
        });
    }

    render() {
        const isCreditSufficient = this.state.isCreditSufficient!=undefined?this.state.isCreditSufficient:true;
        this.state.content.map( content => {
            if(content.documentType === "SERBESTMESLEKMAKBUZ"){
                content.reportType = "eArsivDB.archive_voucher";
            }
        });
        const source = VirtualHost.conf.resourcePrefix;
        const columns = [
            {
                Header: (<input type="checkbox" checked={this.state.selectedAll}
                                onChange={(e) => this.toggleCheckboxChange(e, "all", "recordId")}/>),
                accessor: "recordId",
                selectType: "checkbox",
                sortable: false,
                Cell: (row, index) => (<input type="checkbox" checked={this.isSelected(row.recordId)}
                                              onChange={(e) => this.toggleCheckboxChange(e, row, "recordId", index)}/>)
            },
            {
                Header: "Vkn/Tckn",
                accessor: "vknTckn",
                Cell: (item, i) => (<div style={{textAlign: "center"}}>{item.vknTckn}</div>)
            },
            {
                Header: "Rapor Adı",
                accessor: "name",
                Cell: (item, i) => (<div style={{textAlign: "center"}}>{item.name}</div>)
            },
            {
                Header: "Rapor Tipi",
                accessor: "reportType",
                Cell: (item, i) => (<div style={{textAlign: "center"}}>{this.getReportType(item)}</div>)
            },
            {
                Header: "Tarih Aralığı",
                accessor: "searchField",
                sortable:false,
                Cell: (row) => (
                    <div style={{textAlign: "center"}}>
                        {JSON.parse(row.searchField).map((item) => (item.type==="between" && item.name==='document_issue_date') && (this.getDate(item.start) + "-" +this.getDate(item.end)))}
                    </div>)
            },
            {
                Header: "İstek Tarihi",
                accessor: "createdAt",
                Cell: (item) => (
                    <div style={{textAlign: "center"}}>{this.getTime(item.createdAt)}</div>)
            },
            {
                Header: "Oluşturulma Tarihi",
                accessor: "updatedAt",
                Cell: (item) => (
                    <div style={{textAlign: "center"}}>{this.getTime(item.updatedAt)}</div>)
            },
            {
                Header: "Durum",
                accessor: "result",
                Cell: (item, i) => (<div style={{textAlign: "center"}}>{this.getStatus(item)}</div>)
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: row => (
                    <div>
                        {row.result === "2" && row.path !== null &&
                        <MiniButton title="İndir" faIcon="fa fa-download" color="info" onClick={() => this.download(row)}/>
                        }
                        <MiniButton title="Sil"
                                    faIcon="fa-trash"
                                    color="danger"
                                    style={{margin: "0", background: '#FFCCCC'}}
                                    onClick={() => this.setState({
                                        alert: (
                                            <SweetAlert showCancel warning
                                                        disabled={this.state.deleteBtnDisabled}
                                                        confirmBtnText="Evet"
                                                        cancelBtnText="Hayır"
                                                        confirmBtnBsStyle="danger"
                                                        cancelBtnBsStyle="default"
                                                        title="Emin misiniz?"
                                                        onConfirm={() => {this.deleteRow(row)}}
                                                        onCancel={() => this.setState({alert: null})}
                                            >
                                                Rapor kaydı silinecek.
                                            </SweetAlert>
                                        )
                                    })}/>
                        <MiniButton title="Kopyala" faIcon="fa fa-copy" style={{backgroundColor:"#40A819"}} onClick={() => this.copySelected(row)}/>
                    </div>
                )
            }
        ];

        const fields = [
            {
                label: "Vkn/Tckn",
                accessor: "vknTckn",
                type: "numericText",
                operator: "=",
            },
            {
                label: "Rapor Tipi",
                accessor: ["reportType"],
                type: "select",
                operator: "=",
                selectData: this.state.reportType,
            },
        ];

        return (<div className="row baseBackground">
            <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}
                      btnDisabled={this.state.btnDisabled} name={this.props.name}
                      selection={this.state.selection}>
                    <StickButton position="leftSide"
                                 label="Yeni Oluştur"
                                 title="Yeni Oluştur"
                                 disabled = {!isCreditSufficient}
                                 onClick={()=>this.setState({showSearchModal:true})}
                                 className='stickButton plus-circle'
                                 icon='plus-circle'/>
                <StickButton position="leftSide"
                             title="Seçilileri Sil"
                             label="Seçilileri Sil"
                             className="stickButton trash"
                             disabled={!(this.state.selection.length > 0)}
                             onClick={(e) => this.deleteSelected()}
                             icon='trash'/>
                { showReportSettingButton(EntegratorConf.identifier, this.props.currentUser.vknTckn) &&
                    <StickButton position="leftSide"
                                 title="Rapor Türü Seçimi"
                                 label="Rapor Türü Seçim Ayarı"
                                 disabled = {!isCreditSufficient}
                                 onClick={(e) => this.setState({ showReportSettingsModal: true})}
                                 className="stickButton gear"
                                 icon='gear'
                    />
                }

            </NavBarKS>
            <div className="col-sm-12 satirBasi">
                <div className="card-header">
                    <h4 className="card-title" >{this.props.hasLine ? "Satır Rapor Listesi" :"Genel Rapor Listesi" }</h4>
                </div>
                <div className="card-body">
                    <DetailedSearch fields={fields}
                                    loading={this.state.searching}
                                    onSearch={this.handleSearch}/>
                </div>
                <div className="card-body">
                    <Table columns={columns}
                           content={this.state.content}
                           loading={this.state.loading}
                           total={this.state.total}
                           page={this.state.page}
                           manual={this.state.manual}
                           size={this.state.size}
                           options={["5", "10", "20", "50", "100"]}
                           fetchData={this.fetchData}
                    />
                </div>
            </div>
{/*            {this.state.showSearchModal &&
                <SearchModal show={this.state.showSearchModal}
                            vknTckn={this.props.currentUser.vknTckn}
                            hasLine={this.props.hasLine}
                            mode={this.state.mode}
                            itemToBeCopied={this.state.selectedItem}
                            toggle={()=> this.setState({showSearchModal:false},()=>this.setState({manual:true,mode:'create',selectedItem:null}))}/>
            }  */}
            {this.state.showSearchModal &&
                <BuildReportModal show={this.state.showSearchModal}
                            vknTckn={this.props.currentUser.vknTckn}
                            hasLine={this.props.hasLine}
                            mode={this.state.mode}
                            itemToBeCopied={this.state.selectedItem}
                            sgkCiroReport={this.props.sgkCiroReport}
                            toggle={()=> this.setState({showSearchModal:false},()=>this.setState({manual:true,mode:'create',selectedItem:null}))}/>
            }
            {this.state.alert}

            { this.state.showReportSettingsModal &&
                <ReportSettingModal
                show={this.state.showReportSettingsModal}
                toggle={()=>this.setState({ showReportSettingsModal: false})}

            />}
        </div>)
    }
}

export default ExcelRequest;